import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_DEALSTATUS,
  DELETE_DEALSTATUS,
  UPDATE_DEALSTATUS,
  ADD_NEW_DEALSTATUS,
} from "./actionType";

import {
  getDealStatusSuccess,
  getDealStatusFail,
  deleteDealStatusSuccess,
  deleteDealStatusFail,
  updateDealStatusSuccess,
  updateDealStatusFail,
  addDealStatusSuccess,
  addDealStatusFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveDealStatusApi,
  getDealStatusApi,
  updateDealStatusApi,
  deleteDealStatusApi,
  addNewDealStatusApi,
} from "../../helpers/backend_helper";

function* getDealStatus({ payload: dealStatus }) {
  try {
    const response = yield call(getDealStatusApi, dealStatus);
    yield put(getDealStatusSuccess(GET_DEALSTATUS, response.data));
  } catch (error) {
    yield put(getDealStatusFail(GET_DEALSTATUS, error));
  }
}

function* onUpdateDealStatus({ payload: dealStatus }) {
  try {
    if (dealStatus.setApprove) {
      const response = yield call(approveDealStatusApi, dealStatus);
      yield put(updateDealStatusSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateDealStatusApi, dealStatus);
      yield put(updateDealStatusSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateDealStatusFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteDealStatus({ payload: dealStatus }) {
  try {
    const response = yield call(deleteDealStatusApi, dealStatus);
    yield put(deleteDealStatusSuccess({ dealStatus, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteDealStatusFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewDealStatus({ payload: dealStatus }) {
  try {
    const response = yield call(addNewDealStatusApi, dealStatus);
    yield put(addDealStatusSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addDealStatusFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetDealStatus() {
  yield takeEvery(GET_DEALSTATUS, getDealStatus);
}

export function* watchUpdateDealStatus() {
  yield takeEvery(UPDATE_DEALSTATUS, onUpdateDealStatus);
}

export function* watchDeleteDealStatus() {
  yield takeEvery(DELETE_DEALSTATUS, onDeleteDealStatus);
}

export function* watchAddNewDealStatus() {
  yield takeEvery(ADD_NEW_DEALSTATUS, onAddNewDealStatus);
}

function* dealStatusSaga() {
  yield all([
    fork(watchGetDealStatus),
    fork(watchDeleteDealStatus),
    fork(watchUpdateDealStatus),
    fork(watchAddNewDealStatus),
  ]);
}

export default dealStatusSaga;
